import Icon, { IconName } from "Components/Icons/Icon";
import React from "react";
import { Card, CardBody } from "reactstrap";
import CustomButton from "Components/Custom/CustomButton";
import { useAppSelector } from "Components/Hooks/hooks";

export interface SettingWidgetsType {
  id: number;
  icon: IconName;
  title: string;
  subTitle: string;
  url?: string;
}

interface Props {
  item: SettingWidgetsType;
  onPress?: () => void;
  isLoading?: boolean;
  className?: string;
}

const SettingCard = ({ item, onPress, isLoading, className }: Props) => {
  const isButtonMode = item.url === undefined;
  const user = useAppSelector((state) => state.auth.user);

  return (
    <Card
      className={`settings-card shadow-sm border-0${
        className ? ` ${className}` : ""
      }`}
      onClick={isButtonMode ? undefined : onPress}
      style={{
        cursor: isButtonMode ? "default" : "pointer",
      }}
    >
      <CardBody className="d-flex gap-3 align-items-start">
        {/* Icon */}
        <div className="avatar-sm flex-shrink-0">
          <span className="avatar-title fs-3 text-primary bg-light br-7">
            <Icon name={item.icon} />
          </span>
        </div>

        {/* Text */}
        <div className="flex-grow-1">
          <h2 className="fs-16 fw-semibold text-black2D mb-1 font-primary">
            {item.title}
          </h2>
          <p className="fs-14 fw-normal text-grey89 mb-0 font-primary">
            {item.subTitle}
          </p>
        </div>

        {/* Button — only shown when url is undefined */}
        {isButtonMode && (
          <CustomButton
            text={
              user?.stripe_account_status === "active" ? "Connected" : "Connect"
            }
            type="button"
            newClassName={
              user?.stripe_account_status === "active"
                ? "bg-green38-light"
                : "bg-green38"
            }
            loading={isLoading}
            onClick={onPress}
            textClassName={`text-align-center fs-14 fw-medium font-primary ${
              user?.stripe_account_status === "active"
                ? "text-green38"
                : "text-white"
            }`}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default SettingCard;
